import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';

// Components
import { AmortizationTableComponent } from './components/amortization-table/amortization-table.component';
import { HeaderPibankComponent } from './components/header-pibank/header-pibank.component';
import { LoginComponent } from './components/login/login.component';
import { ModalGenericComponent } from './components/modal-generic/modal-generic.component';
import { TaxesComponent } from './components/taxes/taxes.component';

// Services
import { ClickOutsideDirective } from './directives/click-outside/click-outside.directive';
import { AuthService } from './services/auth/auth.service';
import { CommonService } from './services/common/common.service';
import { NavigationService } from './services/navigation/navigation.service';
import { UserDataService } from './services/user-data/user-data.service';

// Guards
import { AppraisalAccessGuard } from './guards/appraisal-access/appraisal-access.guard';
import { AuthGuard } from './guards/auth/auth.guard';
import { DocumentationAccessGuard } from './guards/documentation-access/documentation-access.guard';
import { EconomicStudyAccessGuard } from './guards/economic-study-access/economic-study-access.guard';
import { LoggedGuard } from './guards/logged/logged.guard';
import { SignAccessGuard } from './guards/sign-access/sign-access.guard';

// Pipes
import { CapitalizeFirstPipe } from './pipes/capitalize-first/capitalize-first.pipe';

// Directives
import { FooterComponent } from './components/footer/footer.component';
import { LogoutTimeoutModalComponent } from './components/logout-timeout-modal/logout-timeout-modal.component';
import { HiddenElementDirective } from './directives/hidden-element/hidden-element.directive';
import { OnlyLettersDirective } from './directives/only-letters/only-letters.directive';
import { OnlyNumbersDirective } from './directives/only-numbers/only-numbers.directive';
import { InitialStateAccessGuard } from './guards/initial-state-access/initial-state-access.guard';
import { ResultAccessGuard } from './guards/result-access/result-access.guard';
import { SummarySecondHolderGuard } from './guards/summary-second-holder/summary-second-holder.guard';
import { CryptoService } from './services/crypto/crypto.service';

import { ClipboardModule } from 'ngx-clipboard';
import { CaptchaDirective } from './directives/captcha/captcha.directive';
import { OpenToastDirective } from './directives/open-toast/open-toast.directive';
import { OpenLoginGuard } from './guards/open-login.guard';
import { RejectedMortgageGuard } from './guards/rejected-mortgage/rejected-mortgage.guard';
import { FileSizePipe } from './pipes/filesize.pipe';
import { GtmService } from './services/gtm/gtm.service';

@NgModule({
  declarations: [
    HeaderPibankComponent,
    LoginComponent,
    AmortizationTableComponent,
    TaxesComponent,
    ModalGenericComponent,
    ClickOutsideDirective,
    HiddenElementDirective,
    CapitalizeFirstPipe,
    FileSizePipe,
    OnlyNumbersDirective,
    OnlyLettersDirective,
    LogoutTimeoutModalComponent,
    FooterComponent,
    OpenToastDirective,
    CaptchaDirective,
  ],
  imports: [
    ClipboardModule,
    CommonModule,
    RouterModule,
    FormsModule,
    TooltipModule,
    TranslateModule,
    ReactiveFormsModule,
  ],
  providers: [
    CommonService,
    // UserDataService,
    NavigationService,
    AuthGuard,
    LoggedGuard,
    DocumentationAccessGuard,
    EconomicStudyAccessGuard,
    AppraisalAccessGuard,
    SignAccessGuard,
    InitialStateAccessGuard,
    ResultAccessGuard,
    CryptoService,
    SummarySecondHolderGuard,
    GtmService,
    RejectedMortgageGuard,
    OpenLoginGuard,
  ],
  exports: [
    HeaderPibankComponent,
    FooterComponent,
    ClickOutsideDirective,
    HiddenElementDirective,
    CapitalizeFirstPipe,
    FileSizePipe,
    OnlyLettersDirective,
    OnlyNumbersDirective,
    OpenToastDirective,
    LoginComponent,
    CaptchaDirective,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [CommonService, UserDataService, AuthService, GtmService],
    };
  }
}
